module.exports = __webpack_public_path__ + "img/cartno.a42c910f.png";